<script setup lang="ts">
import { useModal } from "shared/composables";

defineProps({
	title: {
		type: String,
		default: "Title",
		required: true
	}
});

const { isModalOpened, toggleModal } = useModal();
isModalOpened.value = true;
</script>

<template>
	<div>
		<div
			class="flex items-center justify-between select-none hover:cursor-pointer"
			@click="toggleModal"
		>
			<span class="uppercase font-medium text-xl">
				{{ title }}
			</span>
			<Icon v-if="isModalOpened" name="teenyicons:up-solid" size="12" />
			<Icon v-else name="teenyicons:down-solid" size="12" />
		</div>
		<div v-show="isModalOpened" class="mt-3">
			<slot></slot>
		</div>
	</div>
</template>
